import axios from "axios";
import axiosInstance from "../../Hooks/axoisInstance";
import { API_BASE_URL, API_BASE_URL1} from "../Services/baseApiUrl";

const getToken = () => localStorage.getItem("token");

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

const toList = (data) => (Array.isArray(data) ? data : data?.data || []);

export const getAllZones = async ({ isActive = true, zoneFilter } = {}) => {
  const params = new URLSearchParams();
  params.append("IsActive", String(isActive));
  if (zoneFilter !== undefined && zoneFilter !== null && zoneFilter !== "") {
    params.append("ZoneFilter", zoneFilter);
  }

  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllZone?${params.toString()}`,
    authHeaders()
  );
  return toList(response.data);
};

export const getWardsByZoneId = async (zoneId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetWardByZoneId?ZoneId=${zoneId}`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAllRfidCategories = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllRFIDCategory`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAllInstalledAreas = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllInstalledArea`,
    authHeaders()
  );
  return toList(response.data);
};

export const getRfidTypes = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetRFIDTypes`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAssetCategoryByRfidType = async (assetTypeId) => {
  if (!assetTypeId) return [];
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAssetCategoryByRFIDType?AssetTypeId=${assetTypeId}`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAssetTypes = async () => getRfidTypes();

export const getAllShifts = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllShifts`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAllCollectionTypes = async ({ isActive = true } = {}) => {
  const params = new URLSearchParams();
  params.append("IsActive", String(isActive));

  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllCollectionType?${params.toString()}`,
    authHeaders()
  );
  return toList(response.data);
};

export const getVehicleTypeDetailsByCollectionTypeId = async (
  collectionTypeId
) => {
  if (!collectionTypeId) return [];

  const response = await axiosInstance.get(
    `${API_BASE_URL}GetVehicleTypeDetailsByCollectionTypeId?CollectionTypeId=${collectionTypeId}`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAllVehicleCapacityDetails = async ({
  isActive = true,
  vehicleTypeId,
} = {}) => {
  const params = new URLSearchParams();
  params.append("IsActive", String(isActive));
  if (vehicleTypeId) {
    params.append("VehicleTypeId", String(vehicleTypeId));
  }

  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllVehicleCapacityDetail?${params.toString()}`,
    authHeaders()
  );
  return toList(response.data);
};

export const getAllOwnerTypes = async ({ isActive = true } = {}) => {
  const params = new URLSearchParams();
  params.append("IsActive", String(isActive));

  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllOwnerTypes?${params.toString()}`,
    authHeaders()
  );
  return toList(response.data);
};

export const mapInstalledAreaOptions = (list = []) =>
  list
    .filter((item) => (typeof item === "string" ? true : item?.isActive !== false))
    .map((item) => {
      if (typeof item === "string") {
        return { value: item, label: item };
      }

      const assetAreaId = item.assetAreaId ?? item.installedAreaId ?? item.id;
      const label =
        item.assetAreaType ||
        item.installedAreaName ||
        item.areaName ||
        item.name ||
        item.installedArea ||
        "";

      if (assetAreaId == null || !label) return null;

      return {
        value: String(assetAreaId),
        label,
        assetAreaId,
        assetAreaType: label,
      };
    })
    .filter(Boolean);

export const addOrUpdateRfidMaster = async (payload) => {
  const formData = new FormData();

  formData.append("RFIDMasterId", String(payload.rfidMasterId ?? 0));
  formData.append("AssetCategoryId", String(payload.assetCategoryId ?? ""));
  formData.append("RFDeviceName", payload.rfDeviceName ?? "");
  formData.append("ImeiNo", payload.imeiNo ?? "");
  formData.append("Location", payload.location ?? "");
  formData.append("ZoneId", String(payload.zoneId ?? ""));
  formData.append("CircleId", String(payload.circleId ?? ""));
  formData.append("AssetAreaId", String(payload.assetAreaId ?? ""));
  formData.append("OtherNo", payload.otherNo ?? "");
  formData.append("CollectionTypeId", String(payload.collectionTypeId ?? ""));
  formData.append("VehicleTypeId", String(payload.vehicleTypeId ?? ""));
  formData.append("VehicleCapacityId", String(payload.vehicleCapacityId ?? ""));
  formData.append("OwnerTypeId", String(payload.ownerTypeId ?? ""));
  formData.append("InstallDate", payload.installDate ?? "");
  formData.append("DateOfPurchase", payload.dateOfPurchase ?? "");
  formData.append("RFIDTypeId", String(payload.rfidTypeId ?? ""));
  formData.append("WarrantyEXPDate", payload.warrantyExpireDate ?? "");
  formData.append("InsuranceNo", payload.insuranceNo ?? "");
  formData.append("InsuranceValidity", payload.insuranceValidity ?? "");
  formData.append("InsuranceProvider", payload.insuranceProvider ?? "");
  formData.append("Lat", String(payload.lat ?? ""));
  formData.append("Lng", String(payload.lng ?? ""));
  formData.append("Remarks", payload.installationRemarks ?? "");
  formData.append("IsActive", String(Boolean(payload.isActive)));

  if (payload.imgUrl) {
    formData.append("ImgUrl", payload.imgUrl);
  }

  if (payload.imageFile instanceof File) {
    formData.append("file", payload.imageFile);
  }

console.log("=== FormData being sent ===");
for (const [key, value] of formData.entries()) {
  console.log(key, value);
}
console.log("===========================");
  // Use plain axios so FormData gets multipart boundary.
  // axiosInstance defaults to Content-Type: application/json which causes 415.
  const response = await axios.post(
    `${API_BASE_URL}AddOrUpdateRFIDMaster`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return response.data;
};

export const getAllRfidMaster = async ({
  zoneId,
  circleId,
  assetCategoryId,
  shift,
  fromDate,
  toDate,
  pageNumber = 1,
  pageSize = 10,
} = {}) => {
  const params = new URLSearchParams();
  if (zoneId) params.append("ZoneId", zoneId);
  if (circleId) params.append("CircleId", circleId);
  if (assetCategoryId) params.append("AssetCategoryId", assetCategoryId);
  if (shift) params.append("Shift", shift);
  if (fromDate) params.append("FromDate", fromDate);
  if (toDate) params.append("ToDate", toDate);
  params.append("PageNumber", String(pageNumber));
  params.append("PageSize", String(pageSize));

  const response = await axiosInstance.get(
    `${API_BASE_URL}GetAllRFIDMaster?${params.toString()}`,
    authHeaders()
  );
  return response.data;
};

// GetAllRFMasterReport expects date-only: FromDate=YYYY-MM-DD&ToDate=YYYY-MM-DD
// UI keeps datetime-local; strip time before sending.
const formatReportDateForForm = (dateStr) => {
  if (!dateStr) return "";
  const raw = String(dateStr).trim();
  if (!raw) return "";

  const dateMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (dateMatch) return dateMatch[1];

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, "0");
    const day = String(parsed.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return raw;
};

const appendFormField = (formData, key, value) => {
  formData.append(key, value == null || value === "" ? "" : String(value));
};

const appendQueryParam = (params, key, value) => {
  if (value == null || value === "") return;
  params.append(key, String(value));
};

export const normalizeRfMasterReportResponse = (raw) => {
  if (!raw) return { data: [], totalRecords: 0 };

  let body = raw;
  if (typeof body === "string") {
    try {
      body = JSON.parse(body);
    } catch {
      return { data: [], totalRecords: 0 };
    }
  }

  if (
    body?.data &&
    typeof body.data === "object" &&
    !Array.isArray(body.data) &&
    (body.data.statusCode != null || body.data.totalRecords != null)
  ) {
    body = body.data;
  }

  const list = Array.isArray(body)
    ? body
    : Array.isArray(body?.data)
    ? body.data
    : Array.isArray(body?.Data)
    ? body.Data
    : [];

  const firstRow = list[0];
  const bodyTotal = Number(body?.totalRecords ?? body?.TotalRecords);
  const rowTotal = Number(firstRow?.totalCount ?? firstRow?.TotalCount);
  const totalRecords =
    (Number.isFinite(bodyTotal) && bodyTotal > 0 ? bodyTotal : 0) ||
    (Number.isFinite(rowTotal) && rowTotal > 0 ? rowTotal : 0) ||
    list.length;
  const pageSize = Number(body?.pageSize ?? body?.PageSize) || undefined;
  const pageNumber = Number(body?.pageNumber ?? body?.PageNumber) || undefined;
  const totalPages =
    Number(body?.totalPages ?? body?.TotalPages) ||
    (pageSize ? Math.max(1, Math.ceil(totalRecords / pageSize)) : undefined);

  return {
    ...body,
    data: list,
    totalRecords,
    pageSize,
    pageNumber,
    totalPages,
  };
};

const getDefaultReportFromDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 7);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00:00`;
};

const getDefaultReportToDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const getAllRfMasterReport = async ({
  zoneId,
  circleId,
  assetTypeId,
  assetCategoryId,
  shift,
  fromDate,
  toDate,
  pageNumber = 1,
  pageSize = 10,
} = {}) => {
  const params = new URLSearchParams();

  appendQueryParam(params, "ZoneId", zoneId);
  appendQueryParam(params, "WardId", circleId);
  appendQueryParam(params, "AssetTypeId", assetTypeId);
  appendQueryParam(params, "AssetCategoryId", assetCategoryId);
  appendQueryParam(params, "ShiftId", shift);
  appendQueryParam(
    params,
    "FromDate",
    formatReportDateForForm(fromDate || getDefaultReportFromDate())
  );
  appendQueryParam(
    params,
    "ToDate",
    formatReportDateForForm(toDate || getDefaultReportToDate())
  );
  appendQueryParam(params, "PageNumber", pageNumber);
  appendQueryParam(params, "PageSize", pageSize);

  // GetAllRFMasterReport is hosted at /api/GetAllRFMasterReport (not under /v1)
  const reportBaseUrl = String(API_BASE_URL).replace(
    /\/v1\/?$/i,
    "/"
  );
  const query = params.toString();

  const response = await axios.get(
    `${reportBaseUrl}GetAllRFMasterReport${query ? `?${query}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );

  return normalizeRfMasterReportResponse(response.data);
};

export const getAllRfMasterScannedTagByIdAndRange = async ({
  imeiNo,
  fromDate,
  toDate,
} = {}) => {
  const params = new URLSearchParams();
  if (imeiNo) params.append("ImeiNo", imeiNo);
  if (fromDate) params.append("FromDate", formatReportDateForForm(fromDate));
  if (toDate) params.append("ToDate", formatReportDateForForm(toDate));

  const query = params.toString();
  const response = await axios.get(
    `${API_BASE_URL}GetAllRFMasterScannedTagByIdAndRange${query ? `?${query}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );

  return normalizeRfMasterReportResponse(response.data);
};

export const getAssetScanTrackingReportByTagId = async ({ imeiNo } = {}) => {
  const params = new URLSearchParams();
  if (imeiNo) params.append("ImeiNo", imeiNo);

  const query = params.toString();
  const reportBaseUrl = String(API_BASE_URL).replace(
    /\/v1\/?$/i,
    "/"
  );

  const response = await axios.get(
    `${reportBaseUrl}GetAssetScanTrackingReportByTagId${query ? `?${query}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );

  return normalizeRfMasterReportResponse(response.data);
};

export const getRfidStatusHistory = async (rfidMasterId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}GetRFIDStatusHistory?RFIDMasterId=${rfidMasterId}`,
    authHeaders()
  );
  return toList(response.data);
};

// HH Reader API expects date-only: FromDate=YYYY-MM-DD&ToDate=YYYY-MM-DD
// UI keeps datetime-local; strip time before sending.
const formatHandHeldDateTime = (value) => {
  if (!value) return "";
  const raw = String(value).trim();
  if (!raw) return "";

  const dateMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (dateMatch) return dateMatch[1];

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, "0");
    const day = String(parsed.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return raw;
};

export const getRFIDAssetReport = async ({
  circleId,
  assetTypeId,
  assetCategoryId,
  fromDate,
  toDate,
  pageNumber = 1,
  pageSize = 10,
} = {}) => {
  const params = new URLSearchParams();

  appendQueryParam(params, "WardId", circleId);
  appendQueryParam(params, "AssetTypeId", assetTypeId);
  appendQueryParam(params, "AssetCategoryId", assetCategoryId);
  appendQueryParam(params, "FromDate", formatHandHeldDateTime(fromDate));
  appendQueryParam(params, "ToDate", formatHandHeldDateTime(toDate));
  appendQueryParam(params, "PageNumber", pageNumber);
  appendQueryParam(params, "PageSize", pageSize);

  const query = params.toString();
  const response = await axiosInstance.get(
    `${API_BASE_URL1}HHReaderControllerAuthentication/GetRFIDAssetReport${
      query ? `?${query}` : ""
    }`,
    authHeaders()
  );

  return normalizeRfMasterReportResponse(response.data);
};
